import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import HomeRoundedIcon from "@mui/icons-material/HomeRounded";
import TimelineRoundedIcon from "@mui/icons-material/TimelineRounded";
import NotificationsActiveRoundedIcon from "@mui/icons-material/NotificationsActiveRounded";
import SettingsInputComponentRoundedIcon from "@mui/icons-material/SettingsInputComponentRounded";
import LightbulbRoundedIcon from "@mui/icons-material/LightbulbRounded";
import PersonRoundedIcon from "@mui/icons-material/PersonRounded";
import DevicesRoundedIcon from "@mui/icons-material/DevicesRounded";
import WorkspacePremiumRoundedIcon from "@mui/icons-material/WorkspacePremiumRounded";
import LogoutRoundedIcon from "@mui/icons-material/LogoutRounded";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import logo from "../../assets/logo.jpg";
import authService from "../../services/auth";
import { useAlerts } from "../../context/AlertsContext";
import ThemeToggle from "../ThemeToggle/ThemeToggle";
import "./Sidebar.css";

/* Dos grupos: lo que se mira a diario y lo que se toca de vez en cuando.
   Las rutas y las etiquetas no cambian; sólo se separan con una línea. */
const monitoring = [
  { to: "/home", label: "Panel", icon: HomeRoundedIcon },
  { to: "/history", label: "Historial", icon: TimelineRoundedIcon },
  { to: "/alerts", label: "Alertas", icon: NotificationsActiveRoundedIcon, badge: true },
  { to: "/valve-control", label: "Válvula", icon: SettingsInputComponentRoundedIcon },
  { to: "/recommendations", label: "Recomendaciones", icon: LightbulbRoundedIcon },
];

const account = [
  { to: "/devices", label: "Dispositivos", icon: DevicesRoundedIcon },
  { to: "/subscription", label: "Planes", icon: WorkspacePremiumRoundedIcon },
  { to: "/profile", label: "Perfil", icon: PersonRoundedIcon },
];

export default function Sidebar({ open, onClose }) {
  const navigate = useNavigate();
  const { totalUnreadAlerts } = useAlerts();

  const handleLogout = () => {
    authService.logout();
    navigate("/login");
  };

  const renderItem = ({ to, label, icon: Icon, badge }) => (
    <NavLink
      key={to}
      to={to}
      onClick={onClose}
      className={({ isActive }) => `ng-nav__item ${isActive ? "is-active" : ""}`}
    >
      <span className="ng-nav__icon">
        <Icon />
      </span>
      <span className="ng-nav__label">{label}</span>
      {badge && totalUnreadAlerts > 0 && (
        <span className="ng-nav__count" aria-label={`${totalUnreadAlerts} sin leer`}>
          {totalUnreadAlerts > 9 ? "9+" : totalUnreadAlerts}
        </span>
      )}
    </NavLink>
  );

  return (
    <>
      <aside
        className={`ng-sidebar ${open ? "is-open" : ""}`}
        aria-label="Navegación principal"
      >
        <div className="ng-sidebar__head">
          <span className="ng-sidebar__brand">
            <span
              className="ng-sidebar__mark"
              style={{ backgroundImage: `url(${logo})` }}
              aria-hidden="true"
            />
            <span className="ng-sidebar__wordmark">NisaGuard</span>
          </span>
          <button
            type="button"
            className="ng-btn ng-btn--ghost ng-btn--icon ng-btn--sm ng-sidebar__close"
            onClick={onClose}
            aria-label="Cerrar menú"
          >
            <CloseRoundedIcon />
          </button>
        </div>

        <nav className="ng-nav">
          {monitoring.map(renderItem)}
          <span className="ng-nav__sep" role="presentation" />
          {account.map(renderItem)}
        </nav>

        <div className="ng-sidebar__foot">
          <div className="ng-sidebar__theme">
            <span className="ng-sidebar__theme-label">Tema</span>
            <ThemeToggle />
          </div>
          <button
            type="button"
            className="ng-nav__item ng-nav__item--quiet"
            onClick={handleLogout}
          >
            <span className="ng-nav__icon">
              <LogoutRoundedIcon />
            </span>
            <span className="ng-nav__label">Cerrar sesión</span>
          </button>
        </div>
      </aside>

      <div
        className={`ng-sidebar__scrim ${open ? "is-open" : ""}`}
        onClick={onClose}
        aria-hidden="true"
      />
    </>
  );
}
